import styled from 'styled-components';

export const Container = styled.div`
  .summary {
    padding: 22px 16px;
    justify-content: space-between;
  }
  & .data-row {
    & .data-column {
      padding: 0 29px 0 0;
    }
    & .data-column:nth-child(1) {
      flex: 1.6;
    }
    & .data-column:nth-child(2) {
      flex: 1.4;
    }
    & .data-column:nth-child(3) {
      flex: 1;
    }
    & .data-column:nth-child(4) {
      flex: 0.8;
    }
    & .data-column:nth-child(5) {
      flex: 0.8;
    }
    & .data-column:nth-child(6) {
      flex: 0.8;
      padding-right: 15px;
    }
  }
`;

export const ModalTitle = styled.div`
  font-weight: bold;
  color: #3a3a3a;
  margin-bottom: 32px;
  width: 80%;
`;

export const ButtonList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

export const DoubleIconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  margin-bottom: 16px;
  background: none;
  border: 1px solid rgb(228, 228, 228);
  color: rgb(74, 74, 74);
  font-size: 0.875rem;
  line-height: 1;
  border-radius: 2px;
  cursor: pointer;

  .left,
  .right {
    display: flex;
    align-items: center;
  }
`;
